import { useState } from "react";
import { Dialog } from "@mui/material";
import { toast } from "react-toastify";
import { deleteAffiliate, errorText, saveAffiliate } from "./affiliateApi";
import styles from "./affiliates.module.css";

// Create or edit an affiliate; editing also offers delete, confirmed inside the dialog.
export default function AffiliateDialog({ affiliate, customers = 0, onClose, onSaved, onDeleted }) {
  const [name, setName] = useState(affiliate?.name || "");
  const [email, setEmail] = useState(affiliate?.email || "");
  const [busy, setBusy] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim() || busy) return;
    setBusy(true);
    try {
      await saveAffiliate({ _id: affiliate?._id, name: name.trim(), email: email.trim() });
      toast.success(affiliate ? "Affiliate saved" : "Affiliate created");
      onSaved();
    } catch (err) {
      toast.error(errorText(err, "Could not save the affiliate"));
      setBusy(false);
    }
  };

  const remove = async () => {
    setBusy(true);
    try {
      await deleteAffiliate(affiliate._id);
      toast.success("Affiliate deleted");
      onDeleted();
    } catch (err) {
      toast.error(errorText(err, "Could not delete the affiliate"));
      setBusy(false);
    }
  };

  return (
    <Dialog open onClose={onClose} maxWidth="xs" fullWidth PaperProps={{ className: styles.dialog }}>
      <form onSubmit={submit} className={styles.form}>
        <div className={styles.dialogTitle}>{affiliate ? "Edit affiliate" : "New affiliate"}</div>
        <label htmlFor="affiliate-name">Name</label>
        <input id="affiliate-name" value={name} onChange={(e) => setName(e.target.value)} autoFocus required />
        <label htmlFor="affiliate-email">Email (optional)</label>
        <input id="affiliate-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} />

        {confirmDelete ? (
          <div className={styles.confirm}>
            <span>
              Delete {affiliate.name}? {customers > 0 ? `Their ${customers} customers become unlinked.` : ""}
            </span>
            <div className={styles.actions}>
              <button type="button" className={styles.secondary} onClick={() => setConfirmDelete(false)}>
                Keep
              </button>
              <button type="button" className={styles.danger} onClick={remove} disabled={busy}>
                Delete
              </button>
            </div>
          </div>
        ) : (
          <div className={styles.actions}>
            {affiliate && (
              <button type="button" className={styles.link} onClick={() => setConfirmDelete(true)}>
                Delete affiliate
              </button>
            )}
            <button type="button" className={styles.secondary} onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className={styles.primary} disabled={!name.trim() || busy}>
              {affiliate ? "Save" : "Create"}
            </button>
          </div>
        )}
      </form>
    </Dialog>
  );
}
